module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "keyboard-template"
  }, [_c('div', {
    staticClass: "digits"
  }, [_vm._l((12), function(n) {
    return [(n <= 9) ? _c('button', {
      staticClass: "digit fab",
      on: {
        "click": function($event) {
          _vm.keyPress(n)
        }
      }
    }, [_vm._v(_vm._s(n))]) : _vm._e(), _vm._v(" "), (n === 10) ? _c('button', {
      staticClass: "digit fab",
      on: {
        "click": function($event) {
          _vm.keyPress('erase')
        }
      }
    }, [_c('i', {
      staticClass: "icon-backspace"
    })]) : _vm._e(), _vm._v(" "), (n === 11) ? _c('button', {
      staticClass: "digit fab",
      on: {
        "click": function($event) {
          _vm.keyPress(0)
        }
      }
    }, [_vm._v("0")]) : _vm._e(), _vm._v(" "), (n === 12) ? _c('button', {
      staticClass: "digit fab",
      on: {
        "click": function($event) {
          _vm.keyPress('valid')
        }
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })]) : _vm._e()]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-046b6998!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Keyboard.vue
// module id = 105
// module chunks = 2